import React, { useState, useContext } from "react";
import ActionsContext from "common/ActionsContext";
import Modal from "common/Modal.jsx";

const RulesTreeHelpModal = () => {
  const [open, setOpen] = useState(false);
  const actions = useContext(ActionsContext);
  actions.recv("open-help", function () {
    setOpen(true);
  });
  const doClose = () => setOpen(false);
  if (open !== true) {
    return null;
  }

  return (
    <Modal
      title="Subscriber Rate Rules"
      onClose={doClose}
      content={() => (
        <>
           <p>System subscriber Rate rules.</p>
           <p>Subscriber rate rules. Rules that combine profiles and subscriber policies. The profiles define the traffic characteristics and the policy what actions to perform on that traffic. Internet and DPI profiles are not valid in subscriber rules.</p>
        <ul>
          <li><b>INTERFACE</b>: Interface profile.</li>
          <li><b>VLAN</b>: VLAN profile.</li>
          <li><b>SUB-ID</b>: Subscriber ID profile.</li>
          <li><b>SUB-GROUP</b>: Subscriber group profile.</li>
          <li><b>ACCESS</b>: Access addresses profile.</li>
          <li><b>THROUGHPUT</b>: Throughput profile.</li>
          <li><b>DPI</b>: DPI profile.</li>
          <li><b>POLICY</b>: Policy to be fired when rule profiles match.</li>
          <li><b>ACTIONS</b>: Allowed operations on this policy (e.g. delete or edit).</li>
        </ul>
        <p>Click on the <i className="material-icons valign-icon">edit</i> icon to edit an already configured rule.</p>
        <p>Click on the <i className="material-icons valign-icon">delete</i> icon to delete an already configured rule.</p>
        <p>Click on the <span className="hyperlink-text">profile name</span> to edit profile content.</p>
        <p>Click on the <span className="hyperlink-text">policy name</span> to edit policy content.</p>
        <p>Press the <i className="material-icons valign-icon">more_vert</i> icon and then select the <b>Add Rule...</b> option to add a new rule.</p>
        <p>Click on the <i className="material-icons valign-icon">refresh</i> icon to refresh rules information.</p>
        </>
      )}
      onClose={doClose}
    />
  );
};
export default RulesTreeHelpModal;